import { render, staticRenderFns } from "./order_refund_step2_list.vue?vue&type=template&id=025956b0&scoped=true&"
import script from "./order_refund_step2_list.vue?vue&type=script&lang=js&"
export * from "./order_refund_step2_list.vue?vue&type=script&lang=js&"
import style0 from "./order_refund_step2_list.vue?vue&type=style&index=0&id=025956b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025956b0",
  null
  
)

export default component.exports